module.exports = __webpack_public_path__ + "static/media/business-account-setting.b85cb397.svg";